import px from 'prop-types';

export const cartApiOptionsShape = {
    expand: px.arrayOf(px.oneOf(['forms', 'ordertotals', 'savedshippingaddresses', 'savedpayments'])),
    update: px.arrayOf(px.oneOf(['lineitems', 'shipping', 'payment', 'promotions'])),
};

export default px.shape(cartApiOptionsShape);
